var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSlow = function SvgSlow(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 16L6.71884 15.1459C6.58185 15.0546 6.40867 15.0365 6.2558 15.0977L4 16C4 17.1824 4.34954 18.0153 4.63531 18.4987C4.83778 18.8411 5.2235 19 5.62132 19H8.125C8.72563 19 8.98051 18.2354 8.5 17.875C8.18524 17.6389 8 17.2684 8 16.875V16Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 16L15.7442 15.0977C15.5913 15.0365 15.4182 15.0546 15.2812 15.1459L14 16C14 17.1824 14.3495 18.0153 14.6353 18.4987C14.8378 18.8411 15.2235 19 15.6213 19H18.125C18.7256 19 18.9805 18.2354 18.5 17.875C18.1852 17.6389 18 17.2684 18 16.875V16Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.25 12.5C2.88257 14.0747 1.45441 15.0432 0.180299 15.6081C-0.0431404 15.7072 0.048034 16.3 0.292449 16.3H4L3.25 12.5Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 14C18 14 18 7 10.5 7C3 7 3 14 3 14V16C3 16 5.5 17 10.5 17C15.5 17 18 16 18 16V14Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6908 7.79364C19.4723 7.54994 18.287 8.34017 18.0433 9.55868C17.9823 9.8636 17.6667 10.3007 16.9045 10.7581C16.5042 10.9982 16.0732 11.2002 15.6266 11.3378L17.6315 15.397L19.2197 14.6168C20.3324 13.9492 22.0169 12.6363 22.4559 10.4412C22.6996 9.2227 21.9093 8.03734 20.6908 7.79364Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSlow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "slow.bdcafd61493ee6542e56f80edf3bd372.svg";